/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxContextMenuModule } from 'devextreme-angular';
import { ResultContainerComponent } from './result-container.component';
import { SysqueProgressBarModule } from '../../../../../../shared/ui/src/lib/components/sysque-progress-bar';

@NgModule({
  declarations: [ResultContainerComponent],
  imports: [CommonModule, FormsModule, DxContextMenuModule, SysqueProgressBarModule],
  exports: [ResultContainerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ResultContainerModule {}
